/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Fileviewer_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Document viewer" |
*
* @param {Spaces_Fileviewer_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_fileviewer_aria_label = /** @type {((inputs?: Spaces_Fileviewer_Aria_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Fileviewer_Aria_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dokumenten-Betrachter")
	return /** @type {LocalizedString} */ ("Document viewer")
});